import React from 'react';
import { useBreakpoint } from '../../hooks/useBreakpoint';
import Modal from './Modal';
import { BottomSheet } from './BottomSheet';

export function AdaptiveModal({ isOpen, onClose, title, footer, children, ...rest }) {
  const breakpoint = useBreakpoint();

  if (breakpoint === 'mobile') {
    return (
      <BottomSheet isOpen={isOpen} onClose={onClose} title={title} footer={footer}>
        {children}
      </BottomSheet>
    );
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={title} footer={footer} {...rest}>
      {children}
    </Modal>
  );
}
